module.exports = __webpack_public_path__ + "img/penguan.6973e74a.png";